import { useQuery } from '@tanstack/react-query';
import { useAuth } from 'react-oidc-context';
import { HITL_ENABLED } from '../config/features';
import { resolveInstructorAccess } from '../lib/reviewerAccess';
import { getHitlAvailability } from '../services/hitlApi';

/** Build opt-in is necessary, never sufficient: the authenticated server owns
 * runtime availability. An unavailable/failed check cannot expose live actions. */
export function useHitlAvailability() {
  const auth = useAuth();
  const profile = (auth.user?.profile ?? {}) as Record<string, unknown>;
  const allowed = HITL_ENABLED && auth.isAuthenticated &&
    resolveInstructorAccess(profile) === 'staff';
  const query = useQuery({
    queryKey: ['staff-hitl-availability', profile.sub ?? ''],
    queryFn: getHitlAvailability,
    enabled: allowed,
    retry: false,
    staleTime: 0,
    refetchInterval: 30_000,
  });
  return {
    rolloutEnabled: HITL_ENABLED,
    available: allowed && query.isSuccess && !query.isError && query.data.enabled === true,
    pending: allowed && query.isPending,
    error: allowed && query.isError,
    retry: query.refetch,
  };
}
